import { actualizaTipoExtraVuelo, actualizaTipoExtraVueloRegreso, deleteExtraVuelo, deleteExtraVueloRegreso, eliminarEscalaVuelo, eliminarEscalaVueloRegreso, getEscalasVuelo, getEscalasVueloRegreso, getExtrasVuelo, getExtrasVueloRegreso, getVuelosPorCircuito, getVuelosProveedorAll, getVuelosProveedorID, newEscalaVuelo, newEscalaVueloRegreso, newExtraVuelo, newExtraVueloRegreso, newVueloProveedor, putVueloProveedor, updateEscalaVuelo, updateEscalaVueloRegreso, updateExtraVuelo, updateExtraVueloRegreso } from "../services/fligthService"
import { deleteAereoCircuito, getCircuitosIdProveedorTerrestre, getProveedorTerrestreLista, getTerrestresByIdVuelo, newAereoCircuito } from "../services/packageService"
import { getProveedoresAereosCatalogo } from "../services/supplierService"
import { FormatoFecha, FormatoFechaIso } from "../utils/FormatFecha"

//TODO: Este documento pertenece al nuevo flujo de paquetes mayoristas
const dataInicial = {
    arrayVuelos: [],
    catalogoProvAereo: [],
    exito: 0,
    pagina: 0,
    registros: 10,
    filtroProveedor: "NA",
    total: 0,
    openModalCircuitoVuelo: false,
    vueloTarget: {},
    openExtraVueloAction: false,
    listaPaqueteTerrestres: [],
    listaVuelosCircuitos: [],
    proveedorTerrestreTarget: {},
    vueloExtras: [],
    vueloExtrasRegreso: [],
    
    totalVuelosPorCircuito: 0,
    vuelosPorCircuito: [],
    paginaVuelosPorCircuito: 0,
    registrosVuelosPorCircuito: 10,
    filtroVuelosPorCircuito: "NA",

    escalasVuelo: [],
    openEscalasVuelo: false,
    escalaSelected: {},
    escalasVueloRegreso: [],
}

const OBTENER_PROV_VUELO_ALL_ACTION = "OBTENER_PROV_VUELO_ALL_ACTION"
const OBTENER_PROV_VUELO_PAGINA_ACTION = "OBTENER_PROV_VUELO_PAGINA_ACTION"
const OBTENER_PROV_VUELO_REGISTROS_ACTION = "OBTENER_PROV_VUELO_REGISTROS_ACTION"
const OBTENER_PROV_VUELO_PROVEDOR_ACTION = "OBTENER_PROV_VUELO_PROVEDOR_ACTION"
const NUEVO_PROV_VUELO_ACTION = "NUEVO_PROV_VUELO_ACTION"
const ACTUALIZA_PROV_VUELO_ACTION = "ACTUALIZA_PROV_VUELO_ACTION"
const OBTENER_PROV_AEREO_CATALOGO_ACTION = "OBTENER_PROV_AEREO_CATALOGO_ACTION"
//TODO unir vuelos con cirucitos
const NUEVO_CIRCUITO_VUELO_ACTION = "NUEVO_CIRCUITO_VUELO_ACTION"
const OPEN_CIRCUITO_VUELO_ACTION = "OPEN_CIRCUITO_VUELO_ACTION"
const OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES = "OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES"
const OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION = "OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION"
const OPEN_EXTRA_VUELO_ACTION = "OPEN_EXTRA_VUELO_ACTION"

const OBTENER_PROVEEDOR_TERRESTRE_ACTION = "OBTENER_PROVEEDOR_TERRESTRE_ACTION"
const LIMPIAR_PROVEEDOR_TERRESTRE_ACTION = "LIMPIAR_PROVEEDOR_TERRESTRE_ACTION"
const OBTENER_EXTRAS_VUELO_ACTION = "OBTENER_EXTRAS_VUELO_ACTION"
const OBTENER_EXTRAS_VUELO_REGRESO_ACTION = "OBTENER_EXTRAS_VUELO_REGRESO_ACTION"
const NUEVO_EXTRA_VUELO_ACTION = "NUEVO_EXTRA_VUELO_ACTION"
const NUEVO_EXTRA_VUELO_REGRESO_ACTION = "NUEVO_EXTRA_VUELO_REGRESO_ACTION"
const ELIMINAR_EXTRA_VUELO_ACTION = "ELIMINAR_EXTRA_VUELO_ACTION"
const ELIMINAR_EXTRA_VUELO_REGRESO_ACTION = "ELIMINAR_EXTRA_VUELO_REGRESO_ACTION"
const ACTUALIZAR_EXTRA_VUELO_ACTION = "ACTUALIZAR_EXTRA_VUELO_ACTION"
const ACTUALIZAR_EXTRA_TIPO_VUELO_ACTION = "ACTUALIZAR_EXTRA_TIPO_VUELO_ACTION"

const OBTENER_VUELOS_POR_CIRCUITO_ACTION = "OBTENER_VUELOS_POR_CIRCUITO_ACTION"
const OBTENER_VUELOS_POR_CIRCUITO_PAGINA_ACTION = "OBTENER_VUELOS_POR_CIRCUITO_PAGINA_ACTION"
const OBTENER_VUELOS_POR_CIRCUITO_REGISTROS_ACTION = "OBTENER_VUELOS_POR_CIRCUITO_REGISTROS_ACTION"

const EDITAR_VUELO_ACTION = "EDITAR_VUELO_ACTION"
const ELIMINAR_VUELO_ACTION = "ELIMINAR_VUELO_ACTION"

const OPEN_MODAL_ESCALAS_VUELOS_ACTION = "OPEN_MODAL_ESCALAS_VUELOS_ACTION"
const OBTENER_ESCALAS_VUELOS_ACTION = "OBTENER_ESCALAS_VUELOS_ACTION"
const CREAR_ESCALAS_VUELOS_ACTION = "CREAR_ESCALAS_VUELOS_ACTION"
const EDITAR_ESCALAS_VUELO_ACTION = "EDITAR_ESCALAS_VUELO_ACTION"
const ELIMINAR_ESCALAS_VUELO_ACTION = "ELIMINAR_ESCALAS_VUELO_ACTION"

const OBTENER_ESCALAS_VUELO_REGRESO_ACTION = "OBTENER_ESCALAS_VUELO_REGRESO_ACTION"
const CREAR_ESCALAS_VUELO_REGRESO_ACTION = "CREAR_ESCALAS_VUELO_REGRESO_ACTION"
const EDITAR_ESCALAS_VUELO_REGRESO_ACTION = "EDITAR_ESCALAS_VUELO_REGRESO_ACTION"
const ELIMINAR_ESCALAS_VUELO_REGRESO_ACTION = "ELIMINAR_ESCALAS_VUELO_REGRESO_ACTION"

export default function vueloProveedorReducer(state = dataInicial, action) {
    if (action.type === OBTENER_PROV_VUELO_ALL_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total }
    if (action.type === OBTENER_PROV_VUELO_PAGINA_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total, pagina: action.payload.pagina }
    if (action.type === OBTENER_PROV_VUELO_REGISTROS_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total, registros: action.payload.registros }
    if (action.type === OBTENER_PROV_VUELO_PROVEDOR_ACTION)
        return { ...state, arrayVuelos: action.payload.arrayVuelos, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, filtroProveedor: action.payload.filtroProveedor }
    if (action.type === OBTENER_PROV_AEREO_CATALOGO_ACTION)
        return { ...state, catalogoProvAereo: action.payload.catalogoProvAereo }
    if (action.type === NUEVO_PROV_VUELO_ACTION || action.type === ACTUALIZA_PROV_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    // TODO Unir vuelo con cirucuto
    if (action.type === NUEVO_CIRCUITO_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    if (action.type === OPEN_CIRCUITO_VUELO_ACTION)
        return { ...state, openModalCircuitoVuelo: action.payload.openModalCircuitoVuelo, vueloTarget: action.payload.vueloTarget }
    if (action.type === OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES)
        return { ...state, listaPaqueteTerrestres: action.payload.listaPaqueteTerrestres }
    if (action.type === OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION)
        return { ...state, listaVuelosCircuitos: action.payload.listaVuelosCircuitos}
    if (action.type === OBTENER_PROVEEDOR_TERRESTRE_ACTION)
        return { ...state, proveedorTerrestreTarget: action.payload.proveedorTerrestreTarget }
    if (action.type === OPEN_EXTRA_VUELO_ACTION)
        return { ...state, openModalExtraVuelo: action.payload.openModalExtraVuelo, vueloTarget: action.payload.vueloTarget }
    if (action.type === OBTENER_EXTRAS_VUELO_ACTION)
        return { ...state, vueloExtras: action.payload.vueloExtras }
    if (action.type === OBTENER_EXTRAS_VUELO_REGRESO_ACTION)
        return { ...state, vueloExtrasRegreso: action.payload.vueloExtrasRegreso }
    if(action.type === NUEVO_EXTRA_VUELO_ACTION) 
        return { ...state, exito: action.payload.exito }
    if(action.type === NUEVO_EXTRA_VUELO_REGRESO_ACTION) 
        return { ...state, exito: action.payload.exito }
    if(action.type === ACTUALIZAR_EXTRA_VUELO_ACTION) 
        return { ...state, exito: action.payload.exito }
    if(action.type === OBTENER_VUELOS_POR_CIRCUITO_ACTION)
        return { 
            ...state, 
            vuelosPorCircuito: action.payload.vuelosPorCircuito, 
            totalVuelosPorCircuito: action.payload.totalVuelosPorCircuito, 
    }
    if(action.type === OBTENER_VUELOS_POR_CIRCUITO_PAGINA_ACTION)
        return { 
            ...state, 
            vuelosPorCircuito: action.payload.vuelosPorCircuito, 
            totalVuelosPorCircuito: action.payload.totalvuelosPorCircuito, 
            paginaVuelosPorCircuito: action.payload.paginaVuelosPorCircuito,
    }
    if(action.type === OBTENER_VUELOS_POR_CIRCUITO_REGISTROS_ACTION)
        return { 
            ...state, 
            vuelosPorCircuito: action.payload.vuelosPorCircuito, 
            totalVuelosPorCircuito: action.payload.totalVuelosPorCircuito, 
            registrosVuelosPorCircuito: action.payload.registrosVuelosPorCircuito,
    }
    if(action.type === EDITAR_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    if(action.type === ELIMINAR_VUELO_ACTION)
        return { ...state, exito: action.payload.exito}
    if(action.type === OBTENER_ESCALAS_VUELOS_ACTION)
        return { ...state, escalasVuelo: action.payload.escalasVuelo }
    if(action.type === EDITAR_ESCALAS_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    if(action.type === ELIMINAR_ESCALAS_VUELO_ACTION)
        return { ...state, exito: action.payload.exito }
    if(action.type === OBTENER_ESCALAS_VUELO_REGRESO_ACTION)
        return { ...state, escalasVueloRegreso: action.payload.escalasVueloRegreso }
    if(action.type === CREAR_ESCALAS_VUELO_REGRESO_ACTION)
        return { ...state, exito: action.payload.exito }
    if(action.type === EDITAR_ESCALAS_VUELO_REGRESO_ACTION)
        return { ...state, exito: action.payload.exito }
    return { ...state }
}

export const obtenerVuelosProveedorAllAction = () => async (dispatch, getState) => {
    const { pagina, registros, filtroProveedor } = getState().vueloProveedor
    return await getVuelosProveedorAll({ 
            IdProveedor: filtroProveedor, 
            Pagina: pagina + 1, 
            Registros: registros 
        }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_ALL_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
            }
        })
        return Response
    })
}
export const obtenerVuelosProveedorPaginaAction = ({ pagina }) => async (dispatch, getState) => {
    const { registros, filtroProveedor } = getState().vueloProveedor
    return await getVuelosProveedorAll({ IdProveedor: filtroProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_PAGINA_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
                pagina: pagina
            }
        })
        return Response
    })
}
export const obtenerVuelosProveedorRegistrosAction = ({ registros }) => async (dispatch, getState) => {
    const { pagina, filtroProveedor } = getState().vueloProveedor
    return await getVuelosProveedorAll({ IdProveedor: filtroProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_REGISTROS_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
                registros: registros
            }
        })
        return Response
    })
}
export const obtenerVuelosProveedorFiltroProveedorAction = ({ idProveedor }) => async (dispatch, getState) => {
    const { pagina, registros } = dataInicial
    return await getVuelosProveedorAll({ IdProveedor: idProveedor, Pagina: pagina + 1, Registros: registros }).then(Response => {
        dispatch({
            type: OBTENER_PROV_VUELO_PROVEDOR_ACTION,
            payload: {
                arrayVuelos: Response.LVueloProveedor,
                total: Response.Total,
                registros: registros,
                pagina: pagina,
                filtroProveedor: idProveedor
            }
        })
        return Response
    })
}
export const obtenerCatalogoProveedorAereoAction = () => async (dispatch) => {
    return await getProveedoresAereosCatalogo().then(Response => {
        dispatch({
            type: OBTENER_PROV_AEREO_CATALOGO_ACTION,
            payload: {
                catalogoProvAereo: Response
            }
        })
    })
}
export const crearVueloProveedorAction = ({ 
        ClaveVuelo, 
        Disponibilidad, 
        EsRedondo, 
        FechaSalida, 
        IdDestino, 
        IdMoneda, 
        IdOrigen, 
        IdProveedor, 
        IdCatVueloClase,
        IdCatRegion,
        PrecioNeto, 
        VueloRedondo, 
        FechaLlegada, 
        Itinerario, 
        Incluye, 
        NoIncluye,
        lCatIncluye
    }) => async (dispatch) => {

    let vueloRedondo = { 
        ...VueloRedondo, 
        FechaSalida: FormatoFecha({ date: VueloRedondo?.FechaSalida, formato: "yyyy-MM-dd HH:MM" }), 
        FechaLlegada: FormatoFecha({ date:  VueloRedondo?.FechaLlegada, formato: "yyyy-MM-dd HH:MM" }) 
    }
    
    return await newVueloProveedor({
        IdProveedor, 
        IdCatVueloClase,
        IdCatRegion,
        IdMoneda,
        ClaveVuelo,
        PrecioNeto,
        Disponibilidad,
        FechaSalida: FormatoFecha({ date: FechaSalida, formato: "yyyy-MM-dd HH:MM" }),
        FechaLlegada: FormatoFecha({ date: FechaLlegada, formato: "yyyy-MM-dd HH:MM" }),
        IdOrigen,
        IdDestino,
        Itinerario,
        Incluye,
        NoIncluye,
        EsRedondo,
        VueloRedondo: vueloRedondo,
        lCatIncluye
    }).then(Response => {
        dispatch({
            type: NUEVO_PROV_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
// export const actulizaTerrestreAction = ({ IdVueloProveedor }) => async (dispatch) => {
//     return await putVueloProveedor({ IdVueloProveedor }).then(Response => {
//         dispatch({
//             type: ACTUALIZA_PROV_VUELO_ACTION,
//             payload: {
//                 exito: 1
//             }
//         })
//         return Response
//     }).catch(Error => {
//         return Error
//     })
// }

//TODO MEtodos par aunir vuelo con el cirucuito
export const crearVueloCircuito = ({ IdPaqueteCircuito, IdVueloProveedor }) => async (dispatch) => {
    return await newAereoCircuito({ IdPaqueteCircuito, IdVueloProveedor }).then(Response => {
        dispatch({
            type: NUEVO_CIRCUITO_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const openCircuitoVueloAction = ({ vuelo }) => (dispatch) => {
    dispatch({
        type: OPEN_CIRCUITO_VUELO_ACTION,
        payload: {
            openModalCircuitoVuelo: true,
            vueloTarget: vuelo
        }
    })
}
export const closeCircuitoVueloAction = () => (dispatch) => {
    const { openModalCircuitoVuelo, vueloTarget } = dataInicial
    dispatch({
        type: OPEN_CIRCUITO_VUELO_ACTION,
        payload: {
            openModalCircuitoVuelo: openModalCircuitoVuelo,
            vueloTarget: vueloTarget
        }
    })
}
export const obtenerTerrestreAllListaAction = () => async (dispatch) => {
    return await getProveedorTerrestreLista().then(Response => {
        dispatch({
            type: OPTENER_CIRCUITO_VUELO_CATALOGO_TERRESTRES,
            payload: {
                listaPaqueteTerrestres: Response
            }
        })
        return Response
    })
}
export const obtenerCircuitoVueloAction = ({ IdProveedor }) => async (dispatch) => {
    return await getTerrestresByIdVuelo({IdVueloProveedor: IdProveedor, Pagina: 1, Registros: 100}).then(Response => {
        dispatch({
            type: OBTENER_CIRCUITO_VUELO_CONSULTA_ACTION,
            payload: {
                listaVuelosCircuitos: Response.LPaqueteProveedorTerrestre
            }
        })
        return Response
    })
}
export const obetenerCircuitoTerrestreAction = ({ proveedorTerrestreTarget }) => (dispatch) => {
    dispatch({
        type: OBTENER_PROVEEDOR_TERRESTRE_ACTION,
        payload: {
            proveedorTerrestreTarget: proveedorTerrestreTarget
        }
    })
}
export const limpiarProveedorTerrestreAction = () => (dispatch) => {
    dispatch({
        type: LIMPIAR_PROVEEDOR_TERRESTRE_ACTION,
        payload: {
            proveedorTerrestreTarget: {}
        }
    })
}

//* Metodos para editar y eliminar vuelos
export const editarVueloAction = ({ 
    idVueloProveedor, 
    idCatVueloClase,
    idCatRegion,
    idProveedor, 
    idMoneda, 
    claveVuelo, 
    precioNeto, 
    disponibilidad, 
    fechaSalida, 
    fechaLlegada, 
    idOrigen, 
    idDestino, 
    itinerario, 
    incluye, 
    noIncluye, 
    estatus, 
    esRedondo, 
    vueloRedondo,
    lCatIncluye
}) => async (dispatch) => {

    let vueloRedondoData = { 
        ...vueloRedondo, 
        FechaSalida: FormatoFechaIso({ date: vueloRedondo?.FechaSalida, formato: "yyyy-MM-dd'T'HH:mm:ss" }), 
        FechaLlegada: FormatoFechaIso({ date:  vueloRedondo?.FechaLlegada, formato: "yyyy-MM-dd'T'HH:mm:ss" }) 
    }

    return await putVueloProveedor({ 
        IdVueloProveedor: idVueloProveedor, 
        IdCatVueloClase: idCatVueloClase,
        IdCatRegion: idCatRegion,
        IdProveedor: idProveedor, 
        IdMoneda: idMoneda, 
        ClaveVuelo: claveVuelo, 
        PrecioNeto: precioNeto, 
        Disponibilidad: disponibilidad, 
        FechaSalida: FormatoFechaIso({ date: fechaSalida, formato: "yyyy-MM-dd'T'HH:mm:ss" }),
        FechaLlegada: FormatoFechaIso({ date: fechaLlegada, formato: "yyyy-MM-dd'T'HH:mm:ss" }),
        IdOrigen: idOrigen, 
        IdDestino: idDestino, 
        Itinerario: itinerario, 
        Incluye: incluye, 
        NoIncluye: noIncluye, 
        EsRedondo: esRedondo, 
        Estatus: estatus,
        VueloRedondo: vueloRedondoData,
        lCatIncluye
    }).then(Response => {
        dispatch({
            type: EDITAR_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarVueloAction = ({ idVuelo }) => async (dispatch) => {
    return await deleteAereoCircuito({ IdVueloProveedor: idVuelo }).then(Response => {
        dispatch({
            type: ELIMINAR_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

//* Metodos para los extras de los vuelos 
export const openExtraVueloAction = ({ vuelo }) => (dispatch) => {
    dispatch({
        type: OPEN_EXTRA_VUELO_ACTION,
        payload: {
            openModalExtraVuelo: true,
            vueloTarget: vuelo
        }
    })
}
export const closeExtraVueloModalAction = () => (dispatch) => {
    const {openModalExtraVuelo, vueloTarget} = dataInicial

    dispatch({
        type: OPEN_EXTRA_VUELO_ACTION,
        payload: {
            openModalExtraVuelo: openModalExtraVuelo,
            vueloTarget: vueloTarget
        }
    })
}
export const obtenerExtrasVueloAction = ({ vuelo }) => async (dispatch) => {
    return await getExtrasVuelo({IdVuelo: vuelo}).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_VUELO_ACTION,
            payload: {
                vueloExtras: Response
            }
        })
        return Response
    })
}
export const crearExtraVueloAction = ({ idVueloProveedor, idExtra, descripcion, suplemento }) => async (dispatch) => {
    return await newExtraVuelo({
        IdVueloProveedor: idVueloProveedor,
        IdExtra: idExtra,
        Descripcion: descripcion,
        Suplemento: suplemento
    }).then(Response => {
        dispatch({
            type: NUEVO_EXTRA_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerExtrasVueloRegresoAction = ({ vuelo }) => async (dispatch) => {
    return await getExtrasVueloRegreso({IdVuelo: vuelo}).then(Response => {
        dispatch({
            type: OBTENER_EXTRAS_VUELO_REGRESO_ACTION,
            payload: {
                vueloExtrasRegreso: Response
            }
        })
        return Response
    })
}   
export const crearExtraVueloRegresoAction = ({ idVueloRedondo, idExtra, descripcion, suplemento }) => async (dispatch) => {
    return await newExtraVueloRegreso({
        IdVueloRedondo: idVueloRedondo,
        IdExtra: idExtra,
        Descripcion: descripcion,
        Suplemento: suplemento
    }).then(Response => {
        dispatch({
            type: NUEVO_EXTRA_VUELO_REGRESO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarExtraVueloAction = ({ idVueloProveedorExtra }) => async (dispatch) => {
    return await deleteExtraVuelo({
        IdVueloProveedorExtra: idVueloProveedorExtra
    }).then(Response => {
        dispatch({
            type: ELIMINAR_EXTRA_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    })
}
export const eliminarExtraVueloRegresoAction = ({ idVueloRedondoExtra }) => async (dispatch) => {
    return await deleteExtraVueloRegreso({
        IdVueloRedondoExtra: idVueloRedondoExtra
    }).then(Response => {
        dispatch({
            type: ELIMINAR_EXTRA_VUELO_REGRESO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    })
}
export const actualizarExtraVueloAction = ({ idVueloProveedorExtra, idVueloProveedor, idExtra, descripcion, suplemento, estatus }) => async (dispatch) => {
    return await updateExtraVuelo({ 
        IdVueloProveedorExtra: idVueloProveedorExtra,
        IdVueloProveedor: idVueloProveedor, 
        IdExtra: idExtra, 
        Descripcion: descripcion, 
        Estatus: estatus, 
        Suplemento: suplemento 
    }).then(Response => {
        dispatch({
            type: ACTUALIZAR_EXTRA_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })  
}
export const actualizarExtraVueloRegresoAction = ({ idVueloRedondoExtra, idVueloRedondo, idExtra, descripcion, suplemento, estatus }) => async (dispatch) => {
    return await updateExtraVueloRegreso({ 
        IdVueloRedondoExtra: idVueloRedondoExtra,
        IdVueloRedondo: idVueloRedondo, 
        IdExtra: idExtra, 
        Descripcion: descripcion, 
        Suplemento: suplemento, 
        Estatus: estatus 
    }).then(Response => {
        dispatch({
            type: ACTUALIZAR_EXTRA_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })  
}
export const actualizarTipoExtraVueloAction = ({ idExtra, idCatExtra, imagen, extencion }) => async (dispatch) => {
    return await actualizaTipoExtraVuelo({
        idExtra,
        idCatExtra,
        imagen,
        extencion,
    }).then(Response => { 
        dispatch({
            type: ACTUALIZAR_EXTRA_TIPO_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const actualizarTipoExtraVueloRedondoAction = ({ idExtra, idCatExtra, imagen, extencion }) => async (dispatch) => {
    return await actualizaTipoExtraVueloRegreso({
        idExtra,
        idCatExtra,
        imagen,
        extencion
    }).then(Response => {
        dispatch({
            type: ACTUALIZAR_EXTRA_TIPO_VUELO_ACTION,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerVuelosPorCircuitoAction = ({ idPaqueteCircuito }) => async (dispatch, getState) => {
    const { paginaVuelosPorCircuito, registrosVuelosPorCircuito } = getState().vueloProveedor
   
    return await getVuelosPorCircuito({ 
        IdPaqueteCircuito: idPaqueteCircuito, 
        Pagina: paginaVuelosPorCircuito + 1, 
        Registros: registrosVuelosPorCircuito
     }).then(Response => {
        dispatch({
            type: OBTENER_VUELOS_POR_CIRCUITO_ACTION,
            payload: {
                vuelosPorCircuito: Response.LVueloProveedor,
                totalVuelosPorCircuito: Response.Total,
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerPaginaVuelosPorCircuitoAction = ({ idPaqueteCircuito, pagina }) => async (dispatch, getState) => {
    const { registrosVuelosPorCircuito } = getState().vueloProveedor
    
    return await getVuelosPorCircuito({ 
        IdPaqueteCircuito: idPaqueteCircuito, 
        Pagina: pagina + 1, 
        Registros: registrosVuelosPorCircuito 
    }).then(Response => {
        dispatch({
            type: OBTENER_VUELOS_POR_CIRCUITO_PAGINA_ACTION,
            payload: {
                vuelosPorCircuito: Response.LVueloProveedor,
                totalVuelosPorCircuito: Response.Total,
                paginaVuelosPorCircuito: pagina,
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerRegistrosVuelosPorCircuitoAction = ({ idPaqueteCircuito, registros }) => async (dispatch, getState) => {
    const { paginaVuelosPorCircuito } = getState().vueloProveedor

    return await getVuelosPorCircuito({ 
        IdPaqueteCircuito: idPaqueteCircuito, 
        Pagina: paginaVuelosPorCircuito + 1, 
        Registros: registros 
    }).then(Response => {
        dispatch({
            type: OBTENER_VUELOS_POR_CIRCUITO_REGISTROS_ACTION,
            payload: {
                vuelosPorCircuito: Response.LVueloProveedor,
                totalVuelosPorCircuito: Response.Total,
                registrosVuelosPorCircuito: registros,
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

//* Metodos para las escalas de vuelos
export const openModalEscalasVuelo = ({vuelo}) => (dispatch) => {
    dispatch({
        type: OPEN_MODAL_ESCALAS_VUELOS_ACTION,
        payload: {
            openEscalasVuelo: true,
            vueloTarget: vuelo,
        },
    })
}

export const closeModalEscalasVuelo = () => (dispatch) => {
    dispatch({
        type: OPEN_MODAL_ESCALAS_VUELOS_ACTION,
        payload: {
            openEscalasVuelo: false,
        },
    })
}

export const obtenerEscalasVueloAction = ({ idVueloProveedor }) => async (dispatch) => {
    return await getEscalasVuelo({ IdVueloProveedor: idVueloProveedor }).then(Response => {
        dispatch({
            type: OBTENER_ESCALAS_VUELOS_ACTION,
            payload: {
                escalasVuelo: Response,
            },
        })
        return Response
    })
}

export const crearEscalaVueloAction = ({ idVueloProveedor, idCodigo }) => async (dispatch) => {
    return await newEscalaVuelo({
        IdVueloProveedor: idVueloProveedor,
        IdCodigo: idCodigo,
    }).then(Response => {
        dispatch({
            type: CREAR_ESCALAS_VUELOS_ACTION,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const editarEscalaVueloAction = ({ idEscala, orden }) => async (dispatch) => {
    return await updateEscalaVuelo({
        IdEscalaVuelo: idEscala,
        Orden: orden,
    }).then(Response => {
        dispatch({
            type: EDITAR_ESCALAS_VUELO_ACTION,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const eliminarEscalaVuelosAction = ({ idVueloProveedorEscala }) => async (dispatch) => {
    return await eliminarEscalaVuelo({
            IdVueloProveedorEscala: idVueloProveedorEscala 
    }).then(Response => {
        dispatch({
            type: ELIMINAR_ESCALAS_VUELO_ACTION,
            payload: Response
        })
        return Response
    }).catch(Error => {
        return Error
    })  
}

export const obtenerEscalasVueloRegresoAction = ({ idVueloRedondo }) => async (dispatch) => {
    return await getEscalasVueloRegreso({ IdVueloRedondo: idVueloRedondo }).then(Response => {
        dispatch({
            type: OBTENER_ESCALAS_VUELO_REGRESO_ACTION,
            payload: {
                escalasVueloRegreso: Response,
            },
        })
        return Response
    })

}

export const crearEscalaVueloRegresoAction = ({ idVueloRedondo, idCodigo }) => async (dispatch) => {
    return await newEscalaVueloRegreso({
        IdVueloRedondo: idVueloRedondo,
        IdCodigo: idCodigo,
    }).then(Response => {
        dispatch({
            type: CREAR_ESCALAS_VUELO_REGRESO_ACTION,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const actualizaEscalaVueloRegresoAction = ({ idVueloRedondoEscala, orden }) => async (dispatch) => {
    return await updateEscalaVueloRegreso({
        IVueloRedondoEscala: idVueloRedondoEscala,
        Orden: orden,
    }).then(Response => {
        dispatch({
            type: EDITAR_ESCALAS_VUELO_REGRESO_ACTION,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const eliminarEscalaVuelosRegresoAction = ({ idVueloRedondoEscala }) => async (dispatch) => {
    return await eliminarEscalaVueloRegreso({
        IdVueloRedondoEscala: idVueloRedondoEscala,
    }).then(Response => {
        dispatch({
            type: ELIMINAR_ESCALAS_VUELO_REGRESO_ACTION,
            payload: {
                exito: 1,
            },
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
